import {
    GET_ALL_CLIENTS,
    GET_ALL_CLIENTS_SUCCESS,
    CREATE_CLIENT,
    CREATE_CLIENT_SUCCESS,
    EDIT_CLIENT,
    EDIT_CLIENT_SUCCESS,
    DELETE_CLIENT,
    DELETE_CLIENT_SUCCESS,
    GET_CLIENT_BY_ID,
    GET_CLIENT_BY_ID_SUCCESS
} from "../storeTypes";

const initialState = {
    allClients: null,
    clientDetail: null,
    isLoading: false
}

export const clientReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_CLIENTS:
            return {
                ...state,
                isLoading: true,
            };
        case GET_ALL_CLIENTS_SUCCESS:
            return {
                ...state,
                allClients: action.payload,
                isLoading: false,
            };

        case CREATE_CLIENT:
            return {
                ...state,
                isLoading: true,
            };
        case CREATE_CLIENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };

        case EDIT_CLIENT:
            return {
                ...state,
                isLoading: true,
            };
        case EDIT_CLIENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };

        case DELETE_CLIENT:
            return {
                ...state,
                isLoading: true,
            };
        case DELETE_CLIENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };

        case GET_CLIENT_BY_ID:
            return {
                ...state,
                isLoading: true,
            };
        case GET_CLIENT_BY_ID_SUCCESS:
            return {
                ...state,
                clientDetail: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
}
